module.exports = __webpack_public_path__ + "img/boton-flotante.83771345.png";